/* Hearth — theme behaviour */
(() => {
  const routes = (window.theme && window.theme.routes) || { cart_add_url: '/cart/add', cart_change_url: '/cart/change', cart_url: '/cart', root_url: '/' };
  const strings = (window.theme && window.theme.strings) || {};
  const drawer = document.querySelector('[data-cart-drawer]');
  const drawerEnabled = drawer && drawer.dataset.enabled === 'true';
  const isCartPage = !!document.querySelector('[data-cart-page]');
  const sectionUrl = (routes.root_url.endsWith('/') ? routes.root_url : routes.root_url + '/');

  /* ---------- Cart drawer ---------- */
  let lastFocus = null;
  const openDrawer = () => {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    const close = drawer.querySelector('[data-cart-close].icon-btn');
    if (close) close.focus();
  };
  const closeDrawer = () => {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (lastFocus) lastFocus.focus();
  };
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-cart-close]')) closeDrawer();
    const toggle = e.target.closest('[data-cart-toggle]');
    if (toggle && drawerEnabled && !isCartPage) { e.preventDefault(); openDrawer(); }
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeDrawer(); });

  const setCount = (n) => {
    document.querySelectorAll('[data-cart-count]').forEach((el) => {
      el.textContent = n;
      el.classList.toggle('is-empty', n === 0);
    });
  };

  const renderDrawer = (sections) => {
    const html = sections && sections['cart-drawer-content'];
    if (!html) return;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const inner = doc.querySelector('.shopify-section');
    const body = document.querySelector('[data-cart-drawer-body]');
    if (body && inner) body.innerHTML = inner.innerHTML;
  };

  const refreshCart = async () => {
    const res = await fetch(`${sectionUrl}?sections=cart-drawer-content`);
    renderDrawer(await res.json());
    const cart = await (await fetch(`${routes.cart_url}.js`)).json();
    setCount(cart.item_count);
  };

  /* ---------- Add to cart (AJAX) ---------- */
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('[data-product-form]');
    if (!form) return;
    e.preventDefault();
    const btn = form.querySelector('[type=submit]');
    const label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
    try {
      const fd = new FormData(form);
      fd.append('sections', 'cart-drawer-content');
      fd.append('sections_url', window.location.pathname);
      const res = await fetch(`${routes.cart_add_url}.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: fd });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || 'Error');
      if (!drawerEnabled) { window.location.href = routes.cart_url; return; }
      renderDrawer(data.sections);
      const cart = await (await fetch(`${routes.cart_url}.js`)).json();
      setCount(cart.item_count);
      if (btn) btn.textContent = strings.added || 'Added';
      openDrawer();
      setTimeout(() => { if (btn) btn.textContent = label; }, 1500);
    } catch (err) {
      alert(err.message);
    } finally {
      if (btn) { btn.removeAttribute('aria-busy'); btn.disabled = btn.dataset.unavailable === 'true'; }
    }
  });

  /* ---------- Cart line quantity changes ---------- */
  document.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-line-change]');
    if (!b) return;
    const wrap = b.closest('[data-cart-drawer-body], [data-cart-page]');
    if (wrap) wrap.setAttribute('data-cart-busy', '');
    try {
      const res = await fetch(`${routes.cart_change_url}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: Number(b.dataset.lineChange), quantity: Number(b.dataset.qty), sections: ['cart-drawer-content'], sections_url: window.location.pathname })
      });
      const data = await res.json();
      if (isCartPage) { window.location.reload(); return; }
      renderDrawer(data.sections);
      setCount(data.item_count);
    } finally {
      if (wrap) wrap.removeAttribute('data-cart-busy');
    }
  });

  /* ---------- Quantity steppers ---------- */
  document.addEventListener('click', (e) => {
    const minus = e.target.closest('[data-qty-minus]');
    const plus = e.target.closest('[data-qty-plus]');
    if (!minus && !plus) return;
    const input = (minus || plus).closest('[data-qty]').querySelector('input');
    const v = Math.max(1, (parseInt(input.value, 10) || 1) + (plus ? 1 : -1));
    input.value = v;
  });

  /* ---------- Product gallery ---------- */
  const showMedia = (section, id) => {
    section.querySelectorAll('.product__slide').forEach((s) => s.classList.toggle('is-active', s.dataset.mediaId === String(id)));
    section.querySelectorAll('[data-thumb]').forEach((t) => t.setAttribute('aria-current', t.dataset.thumb === String(id)));
  };
  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-thumb]');
    if (!t) return;
    showMedia(t.closest('[data-product-section]'), t.dataset.thumb);
  });

  /* ---------- Variant picker ---------- */
  document.querySelectorAll('[data-product-section]').forEach((section) => {
    const json = section.querySelector('[data-variants]');
    if (!json) return;
    const variants = JSON.parse(json.textContent);
    const idInput = section.querySelector('[data-variant-id]');
    const addBtn = section.querySelector('[data-add-button]');
    const priceWrap = section.querySelector('.product__price');
    const money = (cents) => {
      try { return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD' }).format(cents / 100); }
      catch (_) { return '$' + (cents / 100).toFixed(2); }
    };

    section.addEventListener('change', (e) => {
      if (!e.target.matches('[data-option-index]')) return;
      const selected = [...section.querySelectorAll('[data-option-index]:checked')].map((i) => i.value);
      selected.forEach((v, i) => { const l = section.querySelector(`[data-option-label="${i}"]`); if (l) l.textContent = v; });
      const variant = variants.find((v) => v.options.every((o, i) => o === selected[i]));
      if (!addBtn) return;
      if (!variant) {
        addBtn.disabled = true; addBtn.dataset.unavailable = 'true';
        addBtn.textContent = strings.unavailable || 'Unavailable';
        return;
      }
      if (idInput) idInput.value = variant.id;
      addBtn.disabled = !variant.available;
      addBtn.dataset.unavailable = String(!variant.available);
      addBtn.textContent = variant.available ? (strings.addToCart || 'Add to cart') : (strings.soldOut || 'Sold out');
      if (priceWrap) {
        const sale = variant.compare_at_price && variant.compare_at_price > variant.price;
        priceWrap.innerHTML = `<div class="price${sale ? ' price--sale' : ''}"><span class="price__current">${money(variant.price)}</span>${sale ? `<s class="price__compare">${money(variant.compare_at_price)}</s>` : ''}</div>`;
      }
      if (variant.featured_media) showMedia(section, variant.featured_media.id);
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    });
  });

  /* ---------- Product recommendations ---------- */
  document.querySelectorAll('[data-recommendations]').forEach(async (el) => {
    try {
      const res = await fetch(el.dataset.url);
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('[data-recommendations]');
      if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
    } catch (_) {}
  });

  /* ---------- Theme editor: keep drawer in sync ---------- */
  document.addEventListener('shopify:section:load', () => refreshCart().catch(() => {}));
})();

/* ---------- Countdowns & promo ---------- */
(() => {
  const pad = (n) => String(n).padStart(2, '0');
  const timers = [...document.querySelectorAll('[data-countdown]')];
  const promoSections = document.querySelectorAll('[data-promo]');
  const promoBar = document.querySelector('[data-announcement-promo]');
  const defaultBar = document.querySelector('[data-announcement-default]');

  const isLive = (iso) => { const t = Date.parse(iso); return !isNaN(t) && t > Date.now(); };

  const applyVisibility = () => {
    promoSections.forEach((s) => { if (!isLive(s.dataset.ends)) s.closest('.shopify-section').hidden = true; });
    if (promoBar) {
      const live = isLive(promoBar.dataset.ends);
      promoBar.hidden = !live;
      if (defaultBar) defaultBar.hidden = live;
    }
  };

  const tick = () => {
    timers.forEach((el) => {
      const diff = Math.max(0, Date.parse(el.dataset.countdown) - Date.now());
      const d = Math.floor(diff / 864e5), h = Math.floor(diff / 36e5) % 24, m = Math.floor(diff / 6e4) % 60, s = Math.floor(diff / 1e3) % 60;
      const set = (k, v) => { const n = el.querySelector(`[data-cd="${k}"]`); if (n) n.textContent = v; };
      set('d', d); set('h', pad(h)); set('m', pad(m)); set('s', pad(s));
    });
    applyVisibility();
  };
  if (timers.length || promoSections.length || promoBar) { tick(); setInterval(tick, 1000); }

  document.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-copy-code]');
    if (!b) return;
    const label = b.querySelector('[data-copy-label]');
    try { await navigator.clipboard.writeText(b.dataset.copyCode); if (label) label.textContent = 'Copied!'; }
    catch (_) { if (label) label.textContent = 'Enter at checkout'; }
    setTimeout(() => { if (label) label.textContent = 'Tap to copy'; }, 2000);
  });
})();
